import { render, staticRenderFns } from "./shopping.vue?vue&type=template&id=3e7a3ece"
import script from "./shopping.vue?vue&type=script&lang=js"
export * from "./shopping.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports